var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorSkeletonHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 634,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390 634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skeleton-hand",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.88,0s0,113.84-.14,129.49S79.09,159.84,69.8,218.37C61.16,272.8,56.85,342.08,53,366.47S20.91,482.65,25.5,499.22s15.89,11.33,24,.49,40.84-123,43.37-126c4.44-5.25,7.46,4.22,4.54,15.39-3.65,13.91-37,152.77-38,182.23s28,18.59,33.33,3.79,32.49-132,41.37-159.63,11-17.64,12.4-10c3.22,17.33-.37,118-1.42,152s7.1,66.3,12,68.26c15.31,6.07,31.21-10.13,31.21-56.18,0-23-4.88-75.49,5.33-180,1.3-13.39,9.44,1.08,17.41,23.79s29.08,105.58,36,136,17.95,36.84,26.25,36.85,14.25-15.29,10.19-40.61C280.34,525.91,264,413.19,262.6,393.86s-15.07-65.82-4.46-71.48c19.27-10.29,43.11,24.69,47.72,27.86s12.38,22.81,30.81,35.33,40.29,9.31,44.91,4.66c3.79-3.82-18.95-35.14-30.92-49.17S305,280.49,297.23,256.74c-3.15-9.62-19.21-59.86-36.08-83.81s-22.4-45.13-25.6-62.62S242.61.16,242.61.16Z",
    fill: "#a1b3c2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.93,489.75s3.49-27.31,6.58-32.84,14.24-1,18.09,2.49-8.12,34.1-14.29,35.48S30.32,497.34,31.93,489.75Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.76,451.35s12.89-5,21.06,3.82c2.15,2.3,3-9.2,5.18-18.4s7.76-16.1,8.62-20.25-6.87-6-9.88-6.91S56,405,52.14,404.07s-1.73,9.21-4.75,20.71S35.4,448.61,38.76,451.35Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.58,402.56s-7.86-1.34-8.27-5.48,5.81-12,10.38-24.84,2.51-25.31,5.42-32.67,10.76-.45,12.83,2.31,12-.45,14.06,3.24-5.4,17.44-10.79,27.1-5.51,33.17-10.46,35.47S62.58,402.56,62.58,402.56Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.74,565.78s4.19-41.5,7.89-49.9,17.06-1.49,21.67,3.77-9.74,51.83-17.12,53.93S67.81,577.31,69.74,565.78Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.56,509.67s13.83-7.53,22.59,5.78c2.3,3.5,3.24-14,5.56-28s9.26-30.76,10.19-37.05-10.17-3.92-13.4-5.32-6.42-5.9-10.57-7.3-1.86,14-5.1,31.47S75,505.5,78.56,509.67Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.15,439.35s-8.76-1.76-9.21-7.26,6.47-15.86,11.56-32.94,2.81-33.57,6-43.33,10.93.86,17.73,2.17c8,1.52,15.27-3.65,16.72,2.92,1.16,5.27-6.95,25.91-13,38.72s-7.56,40.83-13.08,43.88S102.15,439.35,102.15,439.35Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.46,567.92s-4.11-41.5-7.79-49.91-17.06-1.53-21.67,3.72,9.62,51.86,17,54S279.36,579.46,277.46,567.92Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.76,511.79s-13.82-7.56-22.6,5.74c-2.31,3.5-3.22-14-5.51-28s-9.19-30.79-10.1-37.08,10.18-3.89,13.41-5.29,6.43-5.88,10.58-7.28,1.83,14,5,31.48S272.37,507.63,268.76,511.79Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,441.43s8.76-1.75,9.23-7.24-6.44-15.88-11.49-33-2.73-33.58-5.95-43.35-10.93.84-17.74,2.14c-8,1.51-15.26-3.69-16.72,2.88-1.18,5.27,6.88,25.93,12.86,38.75s7.48,40.85,13,43.91S245.32,441.43,245.32,441.43Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,601.2s-5.08-44.53-3.32-54.12,16.36-5.07,22-.49,1.94,56.55-4.82,60.26S160.42,613.74,159.75,601.2Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,540.35s11.87-10.77,23.39,1.45c3,3.21.07-15.38-.75-30.58s2.25-34.27,1.76-41.08-10.82-2-14.29-2.84-7.58-4.89-12-5.52,1.28,15.1,2,34.16S151.5,536.7,156,540.35Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.12,459.81s-9-.06-10.62-5.75,2.82-18,4-37-4.69-35.9-3.68-46.84,10.89-1.33,17.84-1.36c8.12,0,14.13-7,17-.36,2.3,5.31-1.06,28.7-4.1,43.42s1.64,44.51-3.09,48.85S163.12,459.81,163.12,459.81Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,341.06s-9.25-4.5-11.16-11.47,6-17.53,9.25-25.36,7.17-48.31,9.38-55.68,15.59-7.34,21.58-5.5,7.37,5.08,12,4.62-1.13,14.1-8.05,19.62-10.71,35.11-11.84,44.79C112.5,326.29,111.11,341.08,93,341.06Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.86,351.76s-10.61,6-19.83,0-.43-25.84,3.26-30.44,11.89-39.19,7.44-57.52,19.39-16.09,23.54-15.17,13.24,6.46,11.68,12-9.56,6.83-16.34,31C136.72,341.11,153.32,337.83,140.86,351.76Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.78,350.89s10.5,6.23,19.83.34.91-25.82-2.69-30.49-11.16-39.41-6.37-57.65-19.08-16.45-23.25-15.6-13.36,6.21-11.91,11.76,9.44,7,15.77,31.3C211.12,340.31,194.58,336.73,206.78,350.89Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,360.72s-9.7,9-20.82,4.46S157.21,336.91,160,331s3.17-45.73-5.86-64.85,16.52-22.05,21.1-22,13.15,4.44,13.13,16.13c0,13.62-6.44,4-7.81,32.11C177.74,350,194.39,342.6,184.62,360.72Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,238.94s.52,16.86,6.47,20.55,8.26,1.16,18.67,11.67c12.47,12.59,14.56,13.51,15.34,21.64s6.55,13.6,19.31,3.26c14.77-12,17.17-18.61,3.35-24.12s-28-13.8-30.6-24.39S236.46,222.1,224.91,238.94Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,308.47s-1.86,5.52,0,10.59,14.45,2.78,20.13,6,18.13,9.69,20.43,18,3.67,15.19,8.74,13.81,7.39-4,12.92-7.5,4.17-11.64-3.21-13.34-22.32-16.45-26.59-22.9-3.18-20.71-12.25-20.26S278.84,305.73,278.24,308.47Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,361.93s.19,2.83,3.94,8.46,13.33,5.29,18.16,9.79,22.47,10,24.09,5.53-4.83-11.82-11.27-18.58-15.63-21.52-19.93-18.05S338.58,359.6,330.52,361.93Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.19,236.52s7.48,3.63,16.53,7.64,19.49.51,21.78,0-1.38-11.08-2.76-18.91-2.53-19.79-7.94-21.64-12.33,10.58-15.57,15.63S114.44,234.26,119.19,236.52Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,244.2s-1.69-6.79-5.78-7.63S160.77,217,157.54,211s-5.45-9.67-5.26-11.51,8.67-8.28,21.73-6.42,18.47,12.44,13.2,23.48.72,24.83-2.51,25.53S170.35,242.1,167,244.2Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,244.22a22.5,22.5,0,0,1-4-13.38c.29-7.82,1.22-12.88,4-14.26s13.83,2.32,22.14-3.66,15.69-7.35,17.53-4.58,7.82,11.1,2.29,17.28S213,236.39,211.29,240.54,191.15,244.22,191.15,244.22Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,224.74s-7.69,2.34-14.75-8.71-2.74-18.73,1.57-20.87,14.15-8.27,17.53-12.25,15.65,2.47,17.2,6.15,3.35,9.21,0,12.58S123.39,223.3,120.62,224.74Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.81,196.13s-2-11.12-8.53-14.47,3.92-15.61,11.3-16.52,22.45-3,24,0,3.05,21.79,0,23.63-23.1,7.34-24.91,7.34Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,190s2.17-18.1,1.25-21.78,17.52,0,21.51,4.93,10.45,9.83,14.44,14.74,8.28,13.51,6.13,16.89-12.31,9.5-26.14,9.48S205.8,202.63,176.92,190Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,149.14s-.63,8.59,3.68,8.29,7.07-6.13,10.15-5.82,10.14,3.39,14.14,1.71,15.17-11.5,5.29-21.33S145.51.05,145.51.05L115.34,0a294.49,294.49,0,0,1,4,75.79C116.13,117.54,112.1,149.14,112.1,149.14Z",
    fill: "#a1b3c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.82,131.7c-4.2,5.58-5,16.56,0,27.92.94,2.16,8.87-5.21,22.7,0s31.34,9.8,37.48,20.27,13.65,5,12.83-7.94-6.34-25.78-10.3-57.69S213.4.13,213.4.13l-41.19,0s7.17,63.77,3.21,92.64S162.38,123,155.82,131.7Z",
    fill: "#a1b3c2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorSkeletonHand);
export default __webpack_public_path__ + "static/media/doctor_skeleton-hand.68a84901e1ecd5a3971736ba2341b82e.svg";
export { ForwardRef as ReactComponent };